import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useSheetTreeDbsByBook from './useSheetTreeDbsByBook';

export interface SheetTree {
  id: string;
  name: string;
  children?: SheetTree[];
}
const useCurrentTree = (bookId: string | null): SheetTree | undefined => {
  const bookDb = useSelector((state: RootState) => state.bookDb);
  const sheetDb = useSelector((state: RootState) => state.sheetDb);
  const [, sheetTrees] = useSheetTreeDbsByBook(bookId || undefined);

  if (Object.keys(sheetDb.sheets).length === 0) return undefined;

  if (bookId && bookDb.books[bookId]) {
    const makeTree = (parentId: string): SheetTree[] => {
      let treeValue: SheetTree[] = [];
      sheetTrees.forEach(sheetTree => {
        const targetId = sheetTree.sheetId;
        if ((sheetTree.bookId === parentId && !sheetTree.parentSheetId) || sheetTree.parentSheetId === parentId) {
          treeValue.push({
            id: targetId,
            name: sheetDb.sheets[targetId].name,
            children: makeTree(targetId)
          });
        }
      })
      return treeValue;
    }
    const currentTree: SheetTree = {
      id: bookId,
      name: bookDb.books[bookId].name,
      children: makeTree(bookId)
    };

    return currentTree;
  } else return undefined;
}

export default useCurrentTree;
